import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box, Button, GlobalStyles } from '@mui/material';
// import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import HomeIcon from '@mui/icons-material/Home'
import SearchIcon from '@mui/icons-material/Search';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import SchoolIcon from '@mui/icons-material/School';
import PersonIcon from '@mui/icons-material/Person';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import EmailIcon from '@mui/icons-material/Email';
import HistoryIcon from '@mui/icons-material/History';
import GroupsIcon from '@mui/icons-material/Groups';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LockIcon from '@mui/icons-material/Lock';
import ApartmentIcon from '@mui/icons-material/Apartment';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import ExtensionIcon from '@mui/icons-material/Extension';
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import { AppProvider } from '@toolpad/core/react-router-dom';
import { type NavigationPageItem, type NavigationSubheaderItem } from '@toolpad/core/AppProvider';
import { DashboardLayout, ToolbarActions } from '@toolpad/core/DashboardLayout';
import { unstable_HistoryRouter as HistoryRouter, Routes, Route, Navigate, useParams, useLocation, useNavigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import myhistory from './myhistory';
import OrganizationPage from './pages/host/MyOrganizationPage';
import MySpacesPage from './pages/host/MySpacesPage';
import SpaceDetailsPage from './pages/host/SpaceDetailsPage';
import CreateSpacePage from './pages/host/CreateSpacePage';
import CreateRoomPage from './pages/host/CreateRoomPage';
import RoomDetailsPage from './pages/host/RoomDetailsPage';
import SearchPage from './pages/public/SearchPage';
import SpaceSearchResultPage from './pages/public/SpaceSearchResultPage';
import GearCatalogPage from './pages/public/GearCatalogPage';
import GearItemDetailPage from './pages/public/GearItemDetailPage';
import SchoolTutorPage from './pages/public/SchoolTutorPage';
import PublicSpacePage from './pages/public/PublicSpacePage';
import PublicOrgPage from './pages/public/PublicOrgPage';
import BookingRequestsPage from './pages/host/RoomBookingRequestsPage';
import MyBookingsPage from './pages/user/MyBookingsPage';
import UserGearRentalsPage from './pages/user/UserGearRentalsPage';
import UserTutorBookingsPage from './pages/user/UserTutorBookingsPage';
import UserTutorBookingDetailsPage from './pages/user/UserTutorBookingDetailsPage';
import RoomBookingDetailsPage from './pages/user/RoomBookingDetailsPage';
import LoginPage from './pages/public/LoginPage';
import VerifyCodePage from './pages/public/VerifyCodePage';
import ProfileCompletionSelectionPage from './pages/public/ProfileCompletionSelectionPage';
import SubscriptionOnboardingPage from './pages/public/SubscriptionOnboardingPage';
import InviteRegisterPage from './pages/public/InviteRegisterPage';
import JoinPage from './pages/public/JoinPage';
import SpaceCalendarPage from './pages/host/SpaceCalendarPage';
import MySubscriptionPage from './pages/host/MySubscriptionPage';
import ChangeSubscriptionPlanPage from './pages/host/ChangeSubscriptionPlanPage';
import StripeConnectPage from './pages/host/StripeConnectPage';
import HostGoogleCalendarPage from './pages/host/HostGoogleCalendarPage';
import HostStudentsPage from './pages/host/HostStudentsPage';
import HostRoomRentersPage from './pages/host/HostRoomRentersPage';
import HostMonthlyEarningsPage from './pages/host/HostMonthlyEarningsPage';
import HostTutorStatisticsPage from './pages/host/HostTutorStatisticsPage';
import HostGearInventoryPage from './pages/host/HostGearInventoryPage';
import HostGearRentalsPage from './pages/host/HostGearRentalsPage';
import HostPassesPage from './pages/host/HostPassesPage';
import HostPassFormPage from './pages/host/HostPassFormPage';
import HostPassOfferDetailsPage from './pages/host/HostPassOfferDetailsPage';
import HostLessonOptionsPage from './pages/host/HostLessonOptionsPage';
import HostLessonOptionFormPage from './pages/host/HostLessonOptionFormPage';
import HostLessonOptionDetailsPage from './pages/host/HostLessonOptionDetailsPage';
import { CalendarIcon } from '@mui/x-date-pickers/icons';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './components/LanguageSwitcher';
import AuthBar from './components/AuthBar';
import ExperimentalFeaturesToggle from './components/ExperimentalFeaturesToggle';
import { authService } from './services/AuthService';
import MyProfilePage from './pages/user/MyProfilePage';
import RewardsPage from './pages/user/RewardsPage';
import UserPassesPage from './pages/user/UserPassesPage';
import UserPassDetailsPage from './pages/user/UserPassDetailsPage';
import PassPurchaseSuccessPage from './pages/user/PassPurchaseSuccessPage';
import PassPurchasePendingPage from './pages/user/PassPurchasePendingPage';
import HostPassInstanceDetailsPage from './pages/host/HostPassInstanceDetailsPage';
import TutorPassInstanceDetailsPage from './pages/tutor/TutorPassInstanceDetailsPage';
import Footer from './components/common/Footer';
import TermsPage from './pages/public/TermsPage';
import PrivacyPage from './pages/public/PrivacyPage';
import CookiesPage from './pages/public/CookiesPage';
import PricingPage from './pages/public/PricingPage';
import Contact from './pages/Contact';
import MyTutorsPage from './pages/host/MyTutorsPage';
import HostTutorBookingRequestsPage from './pages/host/HostTutorBookingRequestsPage';
import SmartLocksPage from './pages/host/SmartLocksPage';
import TutorBookingRequestsPage from './pages/tutor/TutorBookingRequestsPage';
import TutorCalendarPage from './pages/tutor/TutorCalendarPage';
import TutorProfileCompletionPage from './pages/tutor/TutorProfileCompletionPage';
import TutorSearchResultsPage from './pages/public/TutorSearchResultsPage';
import TutorListingPage from './pages/public/TutorListingPage';
import ChatListPage from './pages/chat/ChatListPage';
import ChatDetailPage from './pages/chat/ChatDetailPage';
import ChatUnreadNavBadge from './components/chat/ChatUnreadNavBadge';
import TutorBookingNeedsActionNavBadge, {
  BookingNeedsActionNavBadge,
} from './components/tutor/TutorBookingNeedsActionNavBadge';
import { useChatUnreadCount } from './hooks/useChatUnreadCount';
import { useHasUserTutorBookings } from './hooks/useHasUserTutorBookings';
import { useTutorBookingNeedsActionCount } from './hooks/useTutorBookingNeedsActionCount';
import { useRoomBookingNeedsActionCount } from './hooks/useRoomBookingNeedsActionCount';

import { createAppTheme } from './theme';
import { ThemeContextProvider, useThemeContext } from './contexts/ThemeContext';
import Branding from './components/Branding';
import { GoogleMapsProvider } from './contexts/GoogleMapsContext';
import { ExperimentalFeaturesProvider, useExperimentalFeatures } from './contexts/ExperimentalFeaturesContext';
import OrganizationsPage from './pages/admin/OrganizationsPage';
import AdminSubscriptionPlansPage from './pages/admin/AdminSubscriptionPlansPage';
import UsersPage from './pages/admin/UsersPage';
import GrowthPage from './pages/admin/GrowthPage';
import CampaignsPage from './pages/admin/CampaignsPage';
import SpacesPage from './pages/admin/SpacesPage';
import AuditLogsPage from './pages/admin/AuditLogsPage';
import OrganizationBadge from './components/OrganizationBadge';
import UserBadge from './components/UserBadge';
import ProtectedRoute from './components/ProtectedRoute';
import MobileAppInstallDialog from './components/MobileAppInstallDialog';
import CookieConsentBanner from './components/CookieConsentBanner';
import { hasRoleAccess } from './utils/navigationAccess';
import NavigationRoleSwitcher from './components/NavigationRoleSwitcher';
import {
  filterNavigationByRoleView,
  getAvailableNavigationViews,
  persistNavigationRoleView,
  resolveNavigationRoleView,
  stripRoleMenuHeadersWhenSingleSection,
  type NavigationRoleView,
} from './utils/navigationRoleView';
import { resolveLegacyTutorSearchRedirect } from './utils/tutorSearchMode';
import { SEARCH_TUTORS_PATH, isSpaceSearchPath } from './utils/searchPaths';
import { legacySchoolTutorRedirectPath } from './utils/publicSpaceResolution';
import { GOOGLE_CALENDAR_UI_ENABLED } from './utils/organizationSections';
import { OrganizationType } from './models/Organization';
import { resolveUserOrganizationType } from './services/stripeConnectClient';
import { apiClient, HOST_RETENTION_EVENTS } from './publicApiClient';
import { ORGANIZATION_TYPE_UPDATED_EVENT } from './utils/subscriptionStripeReturn';

const ORGANIZATION_TYPE_STORAGE_KEY = 'organization_type';
const HOST_APP_OPENED_TRACKED_SESSION_KEY = 'host-app-opened-tracked';

function readCachedOrganizationType(userRoles: string[]): OrganizationType | undefined {
  const cached = localStorage.getItem(ORGANIZATION_TYPE_STORAGE_KEY);
  const validTypes = new Set<string>(Object.values(OrganizationType));
  if (!cached || !validTypes.has(cached)) {
    return undefined;
  }
  const organizationType = cached as OrganizationType;
  // Tutor accounts may carry a stale facility-org cache from another session.
  if (
    userRoles.includes('TUTOR') &&
    organizationType !== OrganizationType.INDIVIDUAL_TUTOR
  ) {
    return undefined;
  }
  return organizationType;
}

type DashboardSidebarFooterState = {
  isLoggedIn: boolean;
  availableNavigationViews: NavigationRoleView[];
  activeNavigationView: NavigationRoleView;
  userRoles: string[];
  experimentalFeaturesEnabled: boolean;
  onSwitch: (view: NavigationRoleView) => void;
};

const DashboardSidebarFooterContext = React.createContext<DashboardSidebarFooterState | null>(null);

function DashboardSidebarFooter({ mini }: Readonly<{ mini: boolean }>) {
  const context = React.useContext(DashboardSidebarFooterContext);

  if (!context || !context.isLoggedIn || context.availableNavigationViews.length <= 1) {
    return null;
  }

  return (
    <NavigationRoleSwitcher
      mini={mini}
      activeView={context.activeNavigationView}
      availableViews={context.availableNavigationViews}
      userRoles={context.userRoles}
      experimentalFeaturesEnabled={context.experimentalFeaturesEnabled}
      onSwitch={context.onSwitch}
    />
  );
}

// Extend navigation types to include roles
type ExtendedNavigationPageItem = Omit<NavigationPageItem, 'children'> & {
  roles?: string[];
  experimental?: boolean;
  /** Host rehearsal-room sections; shown only for BUSINESS organizations. */
  hideForIndividualTutor?: boolean;
  /** Host tutor roster / invite / assignment; hidden for REHEARSAL_STUDIO. */
  hideForRehearsalStudio?: boolean;
  /** Shown only for INDIVIDUAL_TUTOR organizations. */
  showForIndividualTutorOnly?: boolean;
  /** User tutor-bookings nav; shown only when the user has ≥1 tutor booking. */
  requiresUserTutorBookings?: boolean;
  children?: ExtendedNavigation;
};

type ExtendedNavigationSubheaderItem = NavigationSubheaderItem & {
  roles?: string[];
  experimental?: boolean;
};

type ExtendedNavigationItem = ExtendedNavigationPageItem | ExtendedNavigationSubheaderItem;

type ExtendedNavigation = ExtendedNavigationItem[];

// Navigation definition
const NAVIGATION: ExtendedNavigation = [
  {
    kind: 'header',
    title: 'navigation.adminMenu',
    roles: ['ADMIN'],
  },
  {
    segment: 'admin/organizations',
    title: 'navigation.organizations',
    icon: <PeopleIcon />,
    roles: ['ADMIN'],
  },
  {
    segment: 'admin/plans',
    title: 'navigation.plans',
    icon: <CardMembershipIcon />,
    roles: ['ADMIN'],
  },
  {
    segment: 'admin/users',
    title: 'navigation.users',
    icon: <PersonIcon />,
    roles: ['ADMIN'],
  },
  {
    segment: 'admin/growth',
    title: 'navigation.growth',
    icon: <TrendingUpIcon />,
    roles: ['ADMIN'],
  },
  {
    segment: 'admin/campaigns',
    title: 'navigation.campaigns',
    icon: <EmailIcon />,
    roles: ['ADMIN'],
  },
  {
    segment: 'admin/spaces',
    title: 'navigation.spaces',
    icon: <HomeIcon />,
    roles: ['ADMIN'],
  },
  {
    segment: 'admin/audit-logs',
    title: 'navigation.auditLogs',
    icon: <HistoryIcon />,
    roles: ['ADMIN'],
  },
  {
    segment: 'admin/chats',
    title: 'navigation.supportChats',
    icon: <SupportAgentRoundedIcon />,
    roles: ['ADMIN'],
  },
  {
    kind: 'header',
    title: 'navigation.hostMenu',
    roles: ['HOST'],
  },
  {
    segment: 'host',
    title: 'navigation.group.general',
    icon: <ApartmentIcon />,
    roles: ['HOST'],
    children: [
      {
        segment: 'organization',
        title: 'navigation.organization',
        icon: <PeopleIcon />,
        roles: ['HOST'],
      },
      {
        segment: 'subscription',
        title: 'navigation.planAndBilling',
        icon: <CardMembershipIcon />,
        roles: ['HOST'],
      },
      {
        segment: 'spaces',
        title: 'navigation.spacesAndRooms',
        icon: <HomeIcon />,
        roles: ['HOST'],
      },
    ],
  },
  {
    segment: 'host',
    title: 'navigation.group.products',
    icon: <StorefrontOutlinedIcon />,
    roles: ['HOST'],
    children: [
      {
        segment: 'lesson-options',
        title: 'navigation.lessonOptions',
        icon: <MenuBookIcon />,
        roles: ['HOST'],
      },
      {
        segment: 'passes',
        title: 'navigation.passes',
        icon: <ConfirmationNumberIcon />,
        roles: ['HOST'],
      },
    ],
  },
  {
    segment: 'host/calendar',
    title: 'navigation.calendar',
    icon: <CalendarIcon />,
    roles: ['HOST'],
    hideForIndividualTutor: true,
  },
  {
    segment: 'tutor/calendar',
    title: 'navigation.calendar',
    icon: <CalendarIcon />,
    roles: ['TUTOR'],
    showForIndividualTutorOnly: true,
  },
  {
    segment: 'host/chats',
    title: 'navigation.chats',
    icon: <ForumRoundedIcon />,
    roles: ['HOST'],
  },
  {
    segment: 'host',
    title: 'navigation.group.rehearsals',
    icon: <LibraryMusicIcon />,
    roles: ['HOST'],
    hideForIndividualTutor: true,
    children: [
      {
        segment: 'requests',
        title: 'navigation.bookingRequests',
        icon: <BookOnlineIcon />,
        roles: ['HOST'],
      },
      {
        segment: 'room-renters',
        title: 'navigation.roomRenters',
        icon: <GroupsIcon />,
        roles: ['HOST'],
        hideForIndividualTutor: true,
      },
      {
        segment: 'earnings',
        title: 'navigation.rehearsalEarnings',
        icon: <TrendingUpIcon />,
        roles: ['HOST'],
        hideForIndividualTutor: true,
      },
    ],
  },
  {
    segment: 'host',
    title: 'navigation.group.tutors',
    icon: <SchoolIcon />,
    roles: ['HOST'],
    hideForIndividualTutor: true,
    hideForRehearsalStudio: true,
    children: [
      {
        segment: 'tutors',
        title: 'navigation.tutors',
        icon: <PeopleIcon />,
        roles: ['HOST'],
        hideForRehearsalStudio: true,
      },
      {
        segment: 'tutor-requests',
        title: 'navigation.hostLessonRequests',
        icon: <BookOnlineIcon />,
        roles: ['HOST'],
        hideForRehearsalStudio: true,
      },
      {
        segment: 'students',
        title: 'navigation.students',
        icon: <SchoolIcon />,
        roles: ['HOST'],
        hideForRehearsalStudio: true,
      },
      {
        segment: 'tutor-statistics',
        title: 'navigation.tutorStatistics',
        icon: <SchoolIcon />,
        roles: ['HOST'],
        hideForRehearsalStudio: true,
      },
    ],
  },
  {
    // Nested under /host so Toolpad path joining stays valid (absolute tutor/*
    // segments under a segment-less parent become "//tutor/..." → /listing).
    segment: 'host',
    title: 'navigation.group.tutors',
    icon: <SchoolIcon />,
    roles: ['HOST'],
    showForIndividualTutorOnly: true,
    children: [
      {
        segment: 'my-listing',
        title: 'navigation.myListing',
        icon: <PersonIcon />,
        roles: ['TUTOR'],
      },
      {
        segment: 'my-tutor-requests',
        title: 'navigation.tutorLessons',
        icon: <BookOnlineIcon />,
        roles: ['TUTOR'],
      },
      {
        segment: 'students',
        title: 'navigation.students',
        icon: <SchoolIcon />,
        roles: ['HOST'],
      },
      {
        segment: 'tutor-statistics',
        title: 'navigation.tutorStatistics',
        icon: <SchoolIcon />,
        roles: ['HOST'],
      },
    ],
  },
  {
    segment: 'host',
    title: 'navigation.group.gearRental',
    icon: <Inventory2Icon />,
    roles: ['HOST'],
    experimental: true,
    hideForIndividualTutor: true,
    children: [
      {
        segment: 'gear-inventory',
        title: 'navigation.inventory',
        icon: <HomeIcon />,
        roles: ['HOST'],
        experimental: true,
      },
      {
        segment: 'gear-rentals',
        title: 'navigation.gearRentalRequests',
        icon: <BookOnlineIcon />,
        roles: ['HOST'],
        experimental: true,
      },
    ],
  },
  {
    segment: 'host',
    title: 'navigation.group.integrations',
    icon: <ExtensionIcon />,
    roles: ['HOST'],
    children: [
      {
        segment: 'stripe-connect',
        title: 'navigation.stripeConnect',
        icon: <AccountBalanceIcon />,
        roles: ['HOST'],
      },
      {
        segment: 'google-calendar',
        title: 'navigation.googleCalendar',
        icon: <CalendarMonthIcon />,
        roles: ['HOST'],
      },
      {
        segment: 'smart-locks',
        title: 'navigation.smartLocks',
        icon: <LockIcon />,
        roles: ['HOST'],
      },
    ],
  },
  {
    kind: 'header',
    title: 'navigation.userMenu',
    roles: ['USER', 'HOST', 'ADMIN'],
  },
  {
    segment: 'user/profile',
    title: 'navigation.myProfile',
    icon: <PersonIcon />,
    roles: ['USER'],
  },
  {
    segment: 'user/search',
    title: 'navigation.search',
    icon: <SearchIcon/>,
    roles: ['USER'],
  },
  {
    segment: 'user/rent-gear',
    title: 'navigation.searchGear',
    icon: <SearchIcon />,
    roles: ['USER'],
    experimental: true,
  },
  {
    segment: 'user/tutors',
    title: 'navigation.tutorSearch',
    icon: <PersonSearchIcon />,
    roles: ['USER'],
    experimental: true,
  },
  {
    segment: 'user/bookings',
    title: 'navigation.myBookings',
    icon: <BookOnlineIcon />,
    roles: ['USER'],
  },
  {
    segment: 'user/tutor-bookings',
    title: 'navigation.tutorBookings',
    icon: <SchoolIcon />,
    roles: ['USER'],
    /** Shown only when the user has at least one tutor booking (filtered in DashboardRoutes). */
    requiresUserTutorBookings: true,
  },
  {
    segment: 'user/gear-rentals',
    title: 'navigation.gearRentals',
    icon: <Inventory2Icon />,
    roles: ['USER'],
    experimental: true,
  },
  {
    segment: 'user/chats',
    title: 'navigation.chats',
    icon: <ForumRoundedIcon />,
    roles: ['USER'],
  },
  {
    segment: 'user/rewards',
    title: 'navigation.rewards',
    icon: <CardGiftcardIcon />,
    roles: ['USER'],
  },
  {
    segment: 'user/passes',
    title: 'navigation.myPasses',
    icon: <ConfirmationNumberIcon />,
    roles: ['USER'],
  },
  {
    kind: 'header',
    title: 'navigation.tutorMenu',
    roles: ['TUTOR'],
  },
  {
    segment: 'tutor/listing',
    title: 'navigation.myListing',
    icon: <PersonIcon />,
    roles: ['TUTOR'],
    hideForIndividualTutor: true,
  },
  {
    segment: 'tutor/requests',
    title: 'navigation.tutorLessons',
    icon: <BookOnlineIcon />,
    roles: ['TUTOR'],
    hideForIndividualTutor: true,
  },
  {
    segment: 'tutor/calendar',
    title: 'navigation.calendar',
    icon: <CalendarIcon />,
    roles: ['TUTOR'],
    hideForIndividualTutor: true,
  },
  {
    segment: 'tutor/chats',
    title: 'navigation.chats',
    icon: <ForumRoundedIcon />,
    roles: ['TUTOR'],
  },
];

// Public routes wrapper with StandaloneLanguageSwitcher
const PublicRouteWrapper: React.FC<{ element: React.ReactNode }> = ({ element }) => {
  return <>{element}</>;
};

function RedirectLegacySchoolTutorPage() {
  const { city, spaceName } = useParams();
  if (!city || !spaceName) {
    return <Navigate to="/user/search" replace />;
  }
  return <Navigate to={legacySchoolTutorRedirectPath(city, spaceName)} replace />;
}

function RedirectLegacySearchTutorListing() {
  const { tutorId } = useParams();
  return <Navigate to={`/user/tutors/${tutorId ?? ''}`} replace />;
}

function RedirectLegacyUserWorkspace() {
  const { workspaceId } = useParams();
  return <Navigate to={`/user/chats/${workspaceId ?? ''}`} replace />;
}

function RedirectLegacyTutorWorkspace() {
  const { workspaceId } = useParams();
  return <Navigate to={`/tutor/chats/${workspaceId ?? ''}`} replace />;
}

function RedirectTutorSearchRoot() {
  const location = useLocation();
  const target = resolveLegacyTutorSearchRedirect(location.pathname, location.search.replace(/^\?/, ''));
  return <Navigate to={target} replace />;
}

function DashboardToolbarActions() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { enabled: experimentalFeaturesEnabled } = useExperimentalFeatures();
  const showSearchGear = experimentalFeaturesEnabled && isSpaceSearchPath(location.pathname);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'flex-end',
        gap: { xs: 0.5, sm: 1 },
        flexWrap: 'nowrap',
        overflow: 'visible',
        px: { xs: 1, sm: 0 },
        minHeight: { xs: 56, sm: 64 },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: 0.5, sm: 1 },
          flexShrink: 0,
        }}
      >
        <OrganizationBadge />
        <UserBadge />
        <ToolbarActions />
        <ExperimentalFeaturesToggle />
        {showSearchGear && (
          <Button
            variant="outlined"
            size="small"
            startIcon={<SearchIcon />}
            sx={{ whiteSpace: 'nowrap' }}
            onClick={() => navigate('/rent-gear')}
          >
            {t('navigation.searchGear', 'Search Gear')}
          </Button>
        )}
        <LanguageSwitcher />
        <AuthBar />
      </Box>
    </Box>
  );
}

// Main component with React Router
function DashboardRoutes() {
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = React.useState(authService.getIsLoggedIn());
  const [userRoles, setUserRoles] = React.useState<string[]>(authService.getRoles());
  const [organizationType, setOrganizationType] = React.useState<OrganizationType | undefined>(() =>
    readCachedOrganizationType(authService.getRoles()),
  );
  const [isInitialized, setIsInitialized] = React.useState(false);
  const { t, i18n } = useTranslation();
  const { enabled: experimentalFeaturesEnabled } = useExperimentalFeatures();

  const availableNavigationViews = React.useMemo(
    () => getAvailableNavigationViews(userRoles, experimentalFeaturesEnabled),
    [userRoles, experimentalFeaturesEnabled],
  );

  const [activeNavigationView, setActiveNavigationView] = React.useState<NavigationRoleView>(() =>
    resolveNavigationRoleView({
      pathname: location.pathname,
      userRoles: authService.getRoles(),
      experimentalFeaturesEnabled,
    }),
  );

  React.useEffect(() => {
    const resolved = resolveNavigationRoleView({
      pathname: location.pathname,
      userRoles,
      experimentalFeaturesEnabled,
    });
    setActiveNavigationView(resolved);
    persistNavigationRoleView(resolved);
  }, [location.pathname, userRoles, experimentalFeaturesEnabled]);

  // Initialize AuthService when component mounts
  React.useEffect(() => {
    const initializeAuth = async () => {
      try {
        await authService.initialize();
        // Update states after initialization
        setIsLoggedIn(authService.getIsLoggedIn());
        setUserRoles(authService.getRoles());
        setIsInitialized(true);
      } catch (error) {
        console.error('Failed to initialize auth service:', error);
        // Even if initialization fails, we should still show the app
        // with the current auth state from localStorage
        setIsLoggedIn(authService.getIsLoggedIn());
        setUserRoles(authService.getRoles());
        setIsInitialized(true);
      }
    };

    initializeAuth();
  }, []);

  // Add effect to update states when auth changes
  React.useEffect(() => {
    if (!isInitialized) return; // Don't start checking until initialized

    const checkAuth = () => {
      setIsLoggedIn(authService.getIsLoggedIn());
      setUserRoles(authService.getRoles());
    };

    // Check auth state every second
    const interval = setInterval(checkAuth, 1000);

    // Initial check
    checkAuth();

    return () => clearInterval(interval);
  }, [isInitialized]);

  React.useEffect(() => {
    // Wait until auth has finished restoring. The first render is logged-out
    // even for an existing session, and clearing the flag there made every
    // reload look like a new app open.
    if (!isInitialized) {
      return;
    }
    if (!isLoggedIn) {
      setOrganizationType(undefined);
      sessionStorage.removeItem(HOST_APP_OPENED_TRACKED_SESSION_KEY);
      return;
    }

    const roles = authService.getRoles();
    if (!roles.includes('HOST') && !roles.includes('TUTOR')) {
      setOrganizationType(undefined);
      return;
    }

    let cancelled = false;
    void resolveUserOrganizationType(roles)
      .then((type) => {
        if (cancelled) {
          return;
        }
        if (type) {
          setOrganizationType(type);
          localStorage.setItem(ORGANIZATION_TYPE_STORAGE_KEY, type);
          return;
        }
        setOrganizationType(undefined);
        localStorage.removeItem(ORGANIZATION_TYPE_STORAGE_KEY);
      })
      .catch(() => {
        // Keep cached value when refresh fails.
      });

    return () => {
      cancelled = true;
    };
  }, [isInitialized, isLoggedIn, userRoles]);

  React.useEffect(() => {
    const onOrganizationTypeUpdated = (event: Event) => {
      const type = (event as CustomEvent<OrganizationType>).detail;
      if (type && Object.values(OrganizationType).includes(type)) {
        setOrganizationType(type);
        localStorage.setItem(ORGANIZATION_TYPE_STORAGE_KEY, type);
      }
    };
    window.addEventListener(ORGANIZATION_TYPE_UPDATED_EVENT, onOrganizationTypeUpdated);
    return () => {
      window.removeEventListener(ORGANIZATION_TYPE_UPDATED_EVENT, onOrganizationTypeUpdated);
    };
  }, []);

  React.useEffect(() => {
    if (!isInitialized || !isLoggedIn || !userRoles.includes('HOST')) {
      return;
    }
    if (sessionStorage.getItem(HOST_APP_OPENED_TRACKED_SESSION_KEY)) {
      return;
    }
    sessionStorage.setItem(HOST_APP_OPENED_TRACKED_SESSION_KEY, 'true');
    void apiClient.trackHostRetentionEvent(HOST_RETENTION_EVENTS.APP_OPENED, {
      userId: authService.getUserId(),
      roles: userRoles,
      organizationType,
      path: location.pathname,
    });
    // Once per browser session. Path is captured at first ready render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized, isLoggedIn, userRoles]);

  const userChatUnreadCount = useChatUnreadCount(
    isLoggedIn && userRoles.includes('USER'),
    'user'
  );
  const hostChatUnreadCount = useChatUnreadCount(
    isLoggedIn && userRoles.includes('HOST'),
    'host'
  );
  const tutorChatUnreadCount = useChatUnreadCount(
    isLoggedIn && userRoles.includes('TUTOR') && !userRoles.includes('HOST'),
    'tutor'
  );
  const adminChatUnreadCount = useChatUnreadCount(
    isLoggedIn && userRoles.includes('ADMIN'),
    'admin'
  );
  const hasUserTutorBookings = useHasUserTutorBookings(
    isLoggedIn && isInitialized && userRoles.includes('USER'),
  );
  const userTutorNeedsActionCount = useTutorBookingNeedsActionCount(
    isLoggedIn && isInitialized && userRoles.includes('USER') ? 'user' : null,
  );
  const tutorNeedsActionCount = useTutorBookingNeedsActionCount(
    isLoggedIn && isInitialized && userRoles.includes('TUTOR') ? 'tutor' : null,
  );
  const hostTutorNeedsActionCount = useTutorBookingNeedsActionCount(
    isLoggedIn && isInitialized && userRoles.includes('HOST') ? 'host' : null,
  );
  const userRoomNeedsActionCount = useRoomBookingNeedsActionCount(
    isLoggedIn && isInitialized && userRoles.includes('USER') ? 'user' : null,
  );
  const hostRoomNeedsActionCount = useRoomBookingNeedsActionCount(
    isLoggedIn && isInitialized && userRoles.includes('HOST') ? 'host' : null,
  );

  // Filter navigation items based on user roles
  // Now roles are available immediately from localStorage, so navigation can be computed synchronously
  // Recurses into nested `children` so collapsible groups are translated and role/experimental filtered too.
  const filteredNavigation = React.useMemo(() => {
    const processItems = (items: ExtendedNavigation): ExtendedNavigation => {
      return items
        .filter(item => {
          if (item.experimental && !experimentalFeaturesEnabled) {
            return false;
          }
          if (
            'segment' in item &&
            item.segment === 'google-calendar' &&
            !GOOGLE_CALENDAR_UI_ENABLED
          ) {
            return false;
          }
          if (
            'hideForIndividualTutor' in item &&
            item.hideForIndividualTutor &&
            organizationType === OrganizationType.INDIVIDUAL_TUTOR
          ) {
            return false;
          }
          if (
            'hideForRehearsalStudio' in item &&
            item.hideForRehearsalStudio &&
            organizationType === OrganizationType.REHEARSAL_STUDIO
          ) {
            return false;
          }
          if (
            'showForIndividualTutorOnly' in item &&
            item.showForIndividualTutorOnly &&
            organizationType !== OrganizationType.INDIVIDUAL_TUTOR
          ) {
            return false;
          }
          if (
            'requiresUserTutorBookings' in item &&
            item.requiresUserTutorBookings &&
            !hasUserTutorBookings
          ) {
            return false;
          }
          if (
            'segment' in item &&
            item.segment === 'tutor/chats' &&
            userRoles.includes('HOST')
          ) {
            return false;
          }
          return hasRoleAccess(item.roles, userRoles);
        })
        .map(item => {
          const titleKey =
            'segment' in item &&
            item.segment === 'spaces' &&
            item.title === 'navigation.spacesAndRooms' &&
            organizationType === OrganizationType.INDIVIDUAL_TUTOR
              ? 'navigation.spaces'
              : item.title;
          const translated: ExtendedNavigationItem = {
            ...item,
            title: titleKey ? t(titleKey) : '',
          };
          if ('segment' in translated && translated.segment === 'user/chats') {
            (translated as ExtendedNavigationPageItem).action = (
              <ChatUnreadNavBadge count={userChatUnreadCount} />
            );
          }
          if ('segment' in translated && translated.segment === 'tutor/chats') {
            (translated as ExtendedNavigationPageItem).action = (
              <ChatUnreadNavBadge count={tutorChatUnreadCount} />
            );
          }
          if ('segment' in translated && translated.segment === 'host/chats') {
            (translated as ExtendedNavigationPageItem).action = (
              <ChatUnreadNavBadge count={hostChatUnreadCount} />
            );
          }
          if ('segment' in translated && translated.segment === 'admin/chats') {
            (translated as ExtendedNavigationPageItem).action = (
              <ChatUnreadNavBadge count={adminChatUnreadCount} />
            );
          }
          if ('segment' in translated && translated.segment === 'user/bookings') {
            (translated as ExtendedNavigationPageItem).action = (
              <BookingNeedsActionNavBadge
                count={userRoomNeedsActionCount}
                labelKey="bookings.needsActionNavBadge"
                labelDefault="{{count}} need action"
              />
            );
          }
          if ('segment' in translated && translated.segment === 'user/tutor-bookings') {
            (translated as ExtendedNavigationPageItem).action = (
              <TutorBookingNeedsActionNavBadge count={userTutorNeedsActionCount} />
            );
          }
          if (
            'segment' in translated &&
            (translated.segment === 'tutor/requests' || translated.segment === 'my-tutor-requests')
          ) {
            (translated as ExtendedNavigationPageItem).action = (
              <TutorBookingNeedsActionNavBadge count={tutorNeedsActionCount} />
            );
          }
          if ('segment' in translated && translated.segment === 'requests') {
            (translated as ExtendedNavigationPageItem).action = (
              <BookingNeedsActionNavBadge
                count={hostRoomNeedsActionCount}
                labelKey="roomBookingRequests.needsActionNavBadge"
                labelDefault="{{count}} need action"
              />
            );
          }
          if ('segment' in translated && translated.segment === 'tutor-requests') {
            (translated as ExtendedNavigationPageItem).action = (
              <TutorBookingNeedsActionNavBadge count={hostTutorNeedsActionCount} />
            );
          }
          if ('children' in item && item.children) {
            (translated as ExtendedNavigationPageItem).children = processItems(item.children);
          }
          return translated;
        })
        // Drop group items whose children all got filtered out.
        .filter(item => {
          if ('children' in item && Array.isArray((item as ExtendedNavigationPageItem).children)) {
            return ((item as ExtendedNavigationPageItem).children as ExtendedNavigation).length > 0;
          }
          return true;
        });
    };

    const roleFiltered = processItems(NAVIGATION);
    const viewFiltered =
      availableNavigationViews.length <= 1
        ? roleFiltered
        : filterNavigationByRoleView(roleFiltered, activeNavigationView);
    return stripRoleMenuHeadersWhenSingleSection(viewFiltered, {
      alwaysHideHeaders: organizationType === OrganizationType.INDIVIDUAL_TUTOR,
    });
  }, [
    userRoles,
    organizationType,
    t,
    i18n.language,
    experimentalFeaturesEnabled,
    availableNavigationViews,
    activeNavigationView,
    userChatUnreadCount,
    tutorChatUnreadCount,
    hostChatUnreadCount,
    adminChatUnreadCount,
    hasUserTutorBookings,
    userTutorNeedsActionCount,
    tutorNeedsActionCount,
    hostTutorNeedsActionCount,
    userRoomNeedsActionCount,
    hostRoomNeedsActionCount,
  ]);

  const sidebarFooterState = React.useMemo(
    () => ({
      isLoggedIn,
      availableNavigationViews,
      activeNavigationView,
      userRoles,
      experimentalFeaturesEnabled,
      onSwitch: setActiveNavigationView,
    }),
    [activeNavigationView, availableNavigationViews, experimentalFeaturesEnabled, isLoggedIn, userRoles],
  );

  // Show nothing (or minimal loading) while initializing auth
  // Navigation is computed instantly from localStorage-cached roles
  if (!isInitialized) {
    return null;
  }

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      width: '100%'
    }}>
      <GlobalStyles styles={{
        // Clear fixed site footer (--app-footer-height) so page bottoms aren't buried
        '.MuiContainer-root main, main': {
          paddingBottom: 'calc(var(--app-footer-height) + 16px) !important',
        }
      }} />
      <Box sx={{ 
        flex: 1, 
        display: 'flex', 
        minHeight: 0,
        width: '100%',
        position: 'relative'
      }}>
        <DashboardSidebarFooterContext.Provider
          value={sidebarFooterState}
        >
        <DashboardLayout
          hideNavigation={!isLoggedIn}
          hidePageTitle={true}
          sidebarExpandedWidth={232}
          navigation={filteredNavigation}
          slots={{
            sidebarFooter: DashboardSidebarFooter,
            toolbarActions: DashboardToolbarActions,
          }}
        >
        {/* Routes configuration for different segments */}
        <Routes>
          {/* Redirect root to search page */}
          <Route path="/" element={<Navigate to="/user/search" replace />} />
          {/* <Route path="/dashboard" element={<PageContent />} /> */}
          <Route path="/host/organization" element={<ProtectedRoute requiredRoles={['HOST']}><OrganizationPage/></ProtectedRoute>} />
          <Route path="/host/chats" element={<ProtectedRoute requiredRoles={['HOST']}><ChatListPage /></ProtectedRoute>} />
          <Route path="/host/chats/:chatId" element={<ProtectedRoute requiredRoles={['HOST']}><ChatDetailPage /></ProtectedRoute>} />
          <Route path="/host/spaces" element={<ProtectedRoute requiredRoles={['HOST']}><MySpacesPage/></ProtectedRoute>} />
          <Route path="/host/spaces/:id" element={<ProtectedRoute requiredRoles={['HOST']}><SpaceDetailsPage/></ProtectedRoute>} />
          <Route path="/host/spaces/create" element={<ProtectedRoute requiredRoles={['HOST']}><CreateSpacePage/></ProtectedRoute>} />
          <Route path="/host/rooms" element={<ProtectedRoute requiredRoles={['HOST']}><Navigate to="/host/spaces" replace /></ProtectedRoute>} />
          <Route path="/host/rooms/:id" element={<ProtectedRoute requiredRoles={['HOST']}><RoomDetailsPage/></ProtectedRoute>} />
          <Route path="/host/rooms/create" element={<ProtectedRoute requiredRoles={['HOST']}><CreateRoomPage/></ProtectedRoute>} />
          <Route path="/host/subscription" element={<ProtectedRoute requiredRoles={['HOST']}><MySubscriptionPage/></ProtectedRoute>} />
          <Route path="/host/subscription/change" element={<ProtectedRoute requiredRoles={['HOST']}><ChangeSubscriptionPlanPage/></ProtectedRoute>} />
          <Route path="/host/stripe-connect" element={<ProtectedRoute requiredRoles={['HOST']}><StripeConnectPage variant="host" /></ProtectedRoute>} />
          {GOOGLE_CALENDAR_UI_ENABLED && (
            <Route path="/host/google-calendar" element={<ProtectedRoute requiredRoles={['HOST']}><HostGoogleCalendarPage /></ProtectedRoute>} />
          )}
          <Route path="/host/earnings" element={<ProtectedRoute requiredRoles={['HOST']}><HostMonthlyEarningsPage/></ProtectedRoute>} />
          <Route path="/host/tutor-statistics" element={<ProtectedRoute requiredRoles={['HOST']}><HostTutorStatisticsPage/></ProtectedRoute>} />
          <Route path="/user/bookings" element={<ProtectedRoute requiredRoles={['USER']}><MyBookingsPage /></ProtectedRoute>} />
          {experimentalFeaturesEnabled && <Route path="/user/rent-gear" element={<Navigate to="/rent-gear" replace />} />}
          <Route path="/user/tutor-bookings" element={<ProtectedRoute requiredRoles={['USER']}><UserTutorBookingsPage /></ProtectedRoute>} />
          <Route path="/user/tutor-bookings/:id/review" element={<ProtectedRoute requiredRoles={['USER']}><UserTutorBookingDetailsPage /></ProtectedRoute>} />
          <Route path="/user/tutor-bookings/:id" element={<ProtectedRoute requiredRoles={['USER']}><UserTutorBookingDetailsPage /></ProtectedRoute>} />
          <Route path="/user/bookings/:id" element={<ProtectedRoute requiredRoles={['USER']}><RoomBookingDetailsPage /></ProtectedRoute>} />
          <Route path="/user/bookings/:id/review" element={<ProtectedRoute requiredRoles={['USER']}><RoomBookingDetailsPage /></ProtectedRoute>} />
          <Route path="/spaces/:id" element={<PublicSpacePage />} />
          <Route path="/organizations/:id" element={<PublicOrgPage />} />
          <Route path="/user/search/tutors/:tutorId" element={<RedirectLegacySearchTutorListing />} />
          <Route path="/user/search/tutors" element={<Navigate to={resolveLegacyTutorSearchRedirect(SEARCH_TUTORS_PATH, '')} replace />} />
          <Route path="/user/search" element={<SearchPage />} />
          <Route path="/user/search/:city" element={<SearchPage />} />
          <Route path="/user/search/:city/:spaceName/tutors" element={<SchoolTutorPage />} />
          <Route path="/user/search/:city/:spaceName" element={<SpaceSearchResultPage />} />
          <Route path="/user/search/:city/:spaceName/:roomName" element={<SpaceSearchResultPage />} />
          <Route path="/user/search/:city/:spaceName/:roomName/book" element={<SpaceSearchResultPage />} />
          {experimentalFeaturesEnabled && (
            <>
              <Route path="/rent-gear" element={<GearCatalogPage />} />
              <Route path="/rent-gear/:itemId" element={<GearItemDetailPage />} />
            </>
          )}
          <Route path="/user/schools/:city/:spaceName" element={<RedirectLegacySchoolTutorPage />} />
          {/* Room details route removed - gallery opens inline on SpaceSearchResultPage */}
          <Route path="/host/requests/:id" element={<ProtectedRoute requiredRoles={['HOST']}><RoomBookingDetailsPage /></ProtectedRoute>} />
          <Route path="/host/requests" element={<ProtectedRoute requiredRoles={['HOST']}><BookingRequestsPage /></ProtectedRoute>} />
          <Route path="/host/students" element={<ProtectedRoute requiredRoles={['HOST']}><HostStudentsPage /></ProtectedRoute>} />
          <Route path="/host/room-renters" element={<ProtectedRoute requiredRoles={['HOST']}><HostRoomRentersPage /></ProtectedRoute>} />
          <Route path="/host/users" element={<Navigate to="/host/room-renters" replace />} />
          <Route path="/host/calendar" element={<ProtectedRoute requiredRoles={['HOST']}><SpaceCalendarPage /></ProtectedRoute>} />
          <Route path="/host/smart-locks" element={<ProtectedRoute requiredRoles={['HOST']}><SmartLocksPage /></ProtectedRoute>} />
          <Route path="/host/tutors/:tutorId" element={<ProtectedRoute requiredRoles={['HOST']}><TutorProfileCompletionPage /></ProtectedRoute>} />
          <Route path="/host/tutors" element={<ProtectedRoute requiredRoles={['HOST']}><MyTutorsPage /></ProtectedRoute>} />
          <Route path="/host/tutor-requests/:id" element={<ProtectedRoute requiredRoles={['HOST']}><UserTutorBookingDetailsPage /></ProtectedRoute>} />
          <Route path="/host/tutor-requests" element={<ProtectedRoute requiredRoles={['HOST']}><HostTutorBookingRequestsPage /></ProtectedRoute>} />
          <Route path="/host/tutor-calendar" element={<Navigate to="/host/calendar" replace />} />
          <Route path="/host/my-listing" element={<ProtectedRoute requiredRoles={['TUTOR']}><TutorProfileCompletionPage /></ProtectedRoute>} />
          <Route path="/host/my-tutor-requests/:id" element={<ProtectedRoute requiredRoles={['TUTOR']}><UserTutorBookingDetailsPage /></ProtectedRoute>} />
          <Route path="/host/my-tutor-requests" element={<ProtectedRoute requiredRoles={['TUTOR']}><TutorBookingRequestsPage /></ProtectedRoute>} />
          {experimentalFeaturesEnabled && (
            <>
              <Route path="/host/gear-inventory" element={<ProtectedRoute requiredRoles={['HOST']}><HostGearInventoryPage /></ProtectedRoute>} />
              <Route path="/host/gear-rentals" element={<ProtectedRoute requiredRoles={['HOST']}><HostGearRentalsPage /></ProtectedRoute>} />
              <Route path="/user/gear-rentals" element={<ProtectedRoute requiredRoles={['USER']}><UserGearRentalsPage /></ProtectedRoute>} />
            </>
          )}
          <Route path="/tutor/listing" element={<ProtectedRoute requiredRoles={['TUTOR']}><TutorProfileCompletionPage /></ProtectedRoute>} />
          <Route path="/tutor/profile-completion" element={<Navigate to="/tutor/listing" replace />} />
          <Route path="/tutor/requests/:id" element={<ProtectedRoute requiredRoles={['TUTOR']}><UserTutorBookingDetailsPage /></ProtectedRoute>} />
          <Route path="/tutor/requests" element={<ProtectedRoute requiredRoles={['TUTOR']}><TutorBookingRequestsPage /></ProtectedRoute>} />
          {/* Backend notification deep links use /tutor/bookings?bookingId= */}
          <Route path="/tutor/bookings" element={<ProtectedRoute requiredRoles={['TUTOR']}><TutorBookingRequestsPage /></ProtectedRoute>} />
          <Route path="/tutor/calendar" element={<ProtectedRoute requiredRoles={['TUTOR']}><TutorCalendarPage /></ProtectedRoute>} />
          <Route path="/tutor/stripe-connect" element={<ProtectedRoute requiredRoles={['TUTOR']}><StripeConnectPage variant="tutor" /></ProtectedRoute>} />
          <Route path="/tutor/passes/:passId" element={<ProtectedRoute requiredRoles={['TUTOR']}><TutorPassInstanceDetailsPage /></ProtectedRoute>} />
          <Route path="/tutor/chats" element={<ProtectedRoute requiredRoles={['TUTOR']}><ChatListPage /></ProtectedRoute>} />
          <Route path="/tutor/chats/:chatId" element={<ProtectedRoute requiredRoles={['TUTOR']}><ChatDetailPage /></ProtectedRoute>} />
          <Route path="/user/tutors/online" element={<TutorSearchResultsPage />} />
          <Route path="/user/tutors/offline" element={<TutorSearchResultsPage />} />
          <Route path="/user/tutors/results" element={<RedirectTutorSearchRoot />} />
          <Route path="/user/tutors" element={<RedirectTutorSearchRoot />} />
          <Route path="/user/tutors/:tutorId" element={<TutorListingPage />} />
          <Route path="/admin/organizations" element={<ProtectedRoute requiredRoles={['ADMIN']}><OrganizationsPage /></ProtectedRoute>} />
          <Route path="/admin/plans" element={<ProtectedRoute requiredRoles={['ADMIN']}><AdminSubscriptionPlansPage /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute requiredRoles={['ADMIN']}><UsersPage /></ProtectedRoute>} />
          <Route path="/admin/growth" element={<ProtectedRoute requiredRoles={['ADMIN']}><GrowthPage /></ProtectedRoute>} />
          <Route path="/admin/campaigns" element={<ProtectedRoute requiredRoles={['ADMIN']}><CampaignsPage /></ProtectedRoute>} />
          <Route path="/admin/spaces" element={<ProtectedRoute requiredRoles={['ADMIN']}><SpacesPage /></ProtectedRoute>} />
          <Route path="/admin/audit-logs" element={<ProtectedRoute requiredRoles={['ADMIN']}><AuditLogsPage /></ProtectedRoute>} />
          <Route path="/admin/chats" element={<ProtectedRoute requiredRoles={['ADMIN']}><ChatListPage /></ProtectedRoute>} />
          <Route path="/admin/chats/:chatId" element={<ProtectedRoute requiredRoles={['ADMIN']}><ChatDetailPage /></ProtectedRoute>} />
          <Route path="/host/passes" element={<ProtectedRoute requiredRoles={['HOST']}><HostPassesPage /></ProtectedRoute>} />
          <Route path="/host/passes/new" element={<ProtectedRoute requiredRoles={['HOST']}><HostPassFormPage /></ProtectedRoute>} />
          <Route path="/host/passes/instances/:passId" element={<ProtectedRoute requiredRoles={['HOST']}><HostPassInstanceDetailsPage /></ProtectedRoute>} />
          <Route path="/host/passes/:id/edit" element={<ProtectedRoute requiredRoles={['HOST']}><HostPassFormPage /></ProtectedRoute>} />
          <Route path="/host/passes/:id" element={<ProtectedRoute requiredRoles={['HOST']}><HostPassOfferDetailsPage /></ProtectedRoute>} />
          <Route path="/host/lesson-options" element={<ProtectedRoute requiredRoles={['HOST']}><HostLessonOptionsPage /></ProtectedRoute>} />
          <Route path="/host/lesson-options/new" element={<ProtectedRoute requiredRoles={['HOST']}><HostLessonOptionFormPage /></ProtectedRoute>} />
          <Route path="/host/lesson-options/:id/edit" element={<ProtectedRoute requiredRoles={['HOST']}><HostLessonOptionFormPage /></ProtectedRoute>} />
          <Route path="/host/lesson-options/:id" element={<ProtectedRoute requiredRoles={['HOST']}><HostLessonOptionDetailsPage /></ProtectedRoute>} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/verify-code" element={<VerifyCodePage />} />
          <Route path="/listing" element={<PublicRouteWrapper element={<ProfileCompletionSelectionPage />} />} />
          <Route path="/complete-profile" element={<PublicRouteWrapper element={<ProfileCompletionSelectionPage />} />} />
          <Route path="/invite/:role/complete" element={<PublicRouteWrapper element={<ProfileCompletionSelectionPage />} />} />
          <Route path="/invite/:role" element={<PublicRouteWrapper element={<InviteRegisterPage />} />} />
          <Route path="/user/profile" element={<ProtectedRoute requiredRoles={['USER']}><MyProfilePage /></ProtectedRoute>} />
          <Route path="/user/rewards" element={<ProtectedRoute requiredRoles={['USER']}><RewardsPage /></ProtectedRoute>} />
          <Route path="/user/passes" element={<ProtectedRoute requiredRoles={['USER']}><UserPassesPage /></ProtectedRoute>} />
          <Route path="/passes/purchase/success" element={<ProtectedRoute requiredRoles={['USER']}><PassPurchaseSuccessPage /></ProtectedRoute>} />
          <Route path="/passes/purchase/pending" element={<ProtectedRoute requiredRoles={['USER']}><PassPurchasePendingPage /></ProtectedRoute>} />
          <Route path="/passes/:passId" element={<ProtectedRoute requiredRoles={['USER']}><UserPassDetailsPage /></ProtectedRoute>} />
          <Route path="/user/chats" element={<ProtectedRoute requiredRoles={['USER']}><ChatListPage /></ProtectedRoute>} />
          <Route path="/user/chats/:chatId" element={<ProtectedRoute requiredRoles={['USER']}><ChatDetailPage /></ProtectedRoute>} />
          <Route path="/user/workspaces" element={<Navigate to="/user/chats" replace />} />
          <Route path="/user/workspaces/:workspaceId" element={<RedirectLegacyUserWorkspace />} />
          <Route path="/tutor/workspaces" element={<Navigate to="/tutor/chats" replace />} />
          <Route path="/tutor/workspaces/:workspaceId" element={<RedirectLegacyTutorWorkspace />} />
          <Route path="/terms" element={<PublicRouteWrapper element={<TermsPage />} />} />
          <Route path="/privacy" element={<PublicRouteWrapper element={<PrivacyPage />} />} />
          <Route path="/cookies" element={<PublicRouteWrapper element={<CookiesPage />} />} />
          {experimentalFeaturesEnabled && (
            <Route path="/pricing" element={<PublicRouteWrapper element={<PricingPage />} />} />
          )}
          <Route path="/contact" element={<PublicRouteWrapper element={<Contact />} />} />
        </Routes>
        <Footer />
        </DashboardLayout>
        </DashboardSidebarFooterContext.Provider>
      </Box>
    </Box>
  );
}

function AppRoutes() {
  const { t, i18n } = useTranslation();
  const { mode } = useThemeContext();
  const { enabled: experimentalFeaturesEnabled } = useExperimentalFeatures();
  const theme = React.useMemo(() => createAppTheme(mode), [mode]);

  /** Resolve `title` i18n keys on every item; `t` ref can stay stable across language changes. */
  const translatedNavigation = React.useMemo(() => {
    return NAVIGATION.map((item) => {
      if ('kind' in item && item.kind === 'header') {
        return {
          ...item,
          title: item.title ? t(item.title) : '',
        } as ExtendedNavigationSubheaderItem;
      }
      const pageItem = item as ExtendedNavigationPageItem;
      return {
        ...pageItem,
        title: pageItem.title ? t(pageItem.title) : '',
      };
    });
  }, [t, i18n.language]);

  useEffect(() => {
    // Mobile performance optimizations
    const optimizeMobilePerformance = () => {
      // Improve scroll performance
      if ('scrollBehavior' in document.documentElement.style) {
        document.documentElement.style.scrollBehavior = 'smooth';
      }

      // Optimize for mobile viewport
      const viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        viewport.setAttribute('content', 
          'width=device-width, initial-scale=1, maximum-scale=5, user-scalable=yes, shrink-to-fit=no'
        );
      }
    };

    optimizeMobilePerformance();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <HelmetProvider>
        <HistoryRouter history={myhistory}>
          <AppProvider
            navigation={translatedNavigation}
            theme={theme}
            branding={{
              logo: <Branding />,
              title: '',
            }}
          >
            <Box sx={{ 
              width: '100%', 
              minHeight: '100vh',
              position: 'relative'
            }}>
              <Routes>
                {/* Public routes that don't use DashboardLayout */}
                <Route path="/login" element={<PublicRouteWrapper element={<LoginPage />} />} />
                <Route path="/verify-code" element={<PublicRouteWrapper element={<VerifyCodePage />} />} />
                <Route path="/listing" element={<PublicRouteWrapper element={<ProfileCompletionSelectionPage />} />} />
                <Route path="/complete-profile" element={<PublicRouteWrapper element={<ProfileCompletionSelectionPage />} />} />
                {experimentalFeaturesEnabled && (
                  <Route
                    path="/onboarding/plan"
                    element={
                      <PublicRouteWrapper
                        element={
                          <ProtectedRoute>
                            <SubscriptionOnboardingPage />
                          </ProtectedRoute>
                        }
                      />
                    }
                  />
                )}
                <Route path="/invite/:role/complete" element={<PublicRouteWrapper element={<ProfileCompletionSelectionPage />} />} />
                <Route path="/invite/:role" element={<PublicRouteWrapper element={<InviteRegisterPage />} />} />
                <Route path="/join" element={<PublicRouteWrapper element={<JoinPage />} />} />
                <Route path="/join/:joinCode" element={<PublicRouteWrapper element={<JoinPage />} />} />

                {/* Protected routes that use DashboardLayout */}
                <Route path="/*" element={<DashboardRoutes />} />
              </Routes>
              <MobileAppInstallDialog />
              <CookieConsentBanner />
            </Box>
          </AppProvider>
        </HistoryRouter>
      </HelmetProvider>
    </ThemeProvider>
  );
}

// Wrap the entire app with ThemeContextProvider, GoogleMapsProvider, and ExperimentalFeaturesProvider
export default function App() {
  return (
    <ThemeContextProvider>
      <GoogleMapsProvider>
        <ExperimentalFeaturesProvider>
          <Box sx={{ 
            width: '100%', 
            minHeight: '100vh',
            position: 'relative',
            touchAction: 'manipulation'
          }}>
            <AppRoutes />
          </Box>
        </ExperimentalFeaturesProvider>
      </GoogleMapsProvider>
    </ThemeContextProvider>
  );
}
